// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fo","advertDetailContacts__header":"c-o_fp"};